    import React, { useMemo, useState } from 'react'
import { validatePhoneNumber } from '../../../../../ReusableFunctions/reusableFunctions';
import { updateUserData } from '../../../../../apis/users';
import Modal from '../../../../../ReusableComponents/Modal';
import { Button } from '../../../../../Components/Helper';
import Loading from '../../../../../ReusableFunctions/Loader';
import Popup from '../../../../../ReusableFunctions/Popup';
import OTPVerification from '../../../../../ReusableComponents/OTPVerification';
import Select from "react-select";
import {
    getCountryCallingCode,
    getCountries,
    isValidPhoneNumber,
} from "react-phone-number-input";
import ReactCountryFlag from "react-country-flag";
import "react-phone-number-input/style.css";

const customStyles = {
    control: (provided) => ({
        ...provided,
        minWidth: "100px",
        maxWidth: "150px",
        height: "35px",
        paddingBottom: "8px",
        fontSize: "14px",
        border: "none",
        boxShadow: "none",
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: "150px",
        overflowY: "auto",
    }),
    option: (provided) => ({
        ...provided,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 12px",
    }),
    singleValue: (provided) => ({
        ...provided,
        display: "flex",
        alignItems: "center",
        gap: "8px",
    }),
};

const EditPhone = ({ user, open, onClose, onUserUpdate }) => {
    let oldPhone = user.phone
   const normalizedUser = useMemo(() => ({
        ...user,
        country_code: user.country_code?.startsWith('+')
            ? user.country_code
            : `+${user.country_code}`
    }), [user]);
 
    const [userInfo, setUserInfo] = useState(normalizedUser);
    const [error, setError] = useState({
        phone: ''
    });

    const contextDialingCode = userInfo.country_code?.replace(/^\+/, "");

    // Country list setup
    const countryOptions = getCountries().map((country) => {
        const callingCode = getCountryCallingCode(country);
        return {
            value: country,
            code: callingCode,
            label: `${country} +${callingCode}`,
            flag: country,
        };
    });

    const defaultCountry =
        countryOptions.find((c) => c.code === contextDialingCode) ||
        countryOptions.find((c) => c.value === "IN") ||
        countryOptions[0];

    const [selectedCountryOption, setSelectedCountryOption] =
        useState(defaultCountry);

    // Update country code
    const handleCountryChange = (option) => {
        setSelectedCountryOption(option);
        const newCode = `+${getCountryCallingCode(option.value)}`;

        setUserInfo((prev) => ({
            ...prev,
            country_code: newCode
        }))

        validatePhone(userInfo.phone, newCode);
    };

    const onChangeUserInfo = (e) => {
        const name = e.target.name
        const value = e.target.value.replace(/\D/g, "");
        setUserInfo((prev) => ({
            ...prev,
            [name]: value
        }))
        validatePhone(value);
    }

    const validatePhone = (value, customCode) => {
        const countryCode = customCode || userInfo?.country_code;
        let error = "";

        const fullPhone = `${countryCode || ""}${value || ""}`;

        if (!value) error = "Mobile number is required";
        else if (!isValidPhoneNumber(fullPhone)) error = "Invalid number";
        else if (selectedCountryOption.value === "IN" && value.length !== 10)
            error = "Mobile number must be 10 digits";

        setError((prev) => ({ ...prev, phone: error }));
        return error === "" ? false : true;
    };

    const updateProfileInfo = async () => {
        Loading.set(true);
        try {
            await updateUserData({ ...userInfo, country_code: userInfo?.country_code ? userInfo?.country_code?.split("+")[1] : undefined, })
                .then((res) => {
                    onUserUpdate(userInfo)
                    Loading.set(false);
                })
                .catch((e) => {
                    Loading.set(false);
                    console.log(e)
                    Popup.alert(
                        "Profile",
                        e,
                        "ERROR",
                        () => { }
                    );
                })
        } catch (e) {
            Loading(false)
            console.log(e)
            Popup.alert(
                "Profile",
                "Something went wrong while updating profile",
                "ERROR",
                () => { }
            );
        }
    }
    return (
        <Modal
            header={'Edit Number'}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "534px", height: "auto" }}
            divider={true}
            headingStyle={{ fontSize: "18px" }}
            iconSize={"18px"}
            headerContainerStyle={{ padding: '20px 40px' }}
        >
            <div style={{ padding: "15px 46px" }}>
                <p style={{ paddingBottom: "17px", fontSize: '16px', color: '#1e1e1e', fontWeight: 500 }}>
                    Enter your mobile number, we will send otp on that number to verify
                </p>
                <form>

                    <div className="form-input-field">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                border: error?.phone
                                    ? "1px solid #D92D20"
                                    : "1px solid #D0D5DD",
                                borderRadius: "4px",
                                width: "100%",
                                height: "40px",
                            }}
                        >
                            <Select
                                value={selectedCountryOption}
                                onChange={handleCountryChange}
                                options={countryOptions}
                                isSearchable
                                styles={customStyles}
                                formatOptionLabel={(option) => (
                                    <div
                                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                    >
                                        <ReactCountryFlag
                                            countryCode={option.flag}
                                            svg
                                            style={{ width: "1.2em", height: "1.2em" }}
                                        />
                                        <span>+{option.code}</span>
                                    </div>
                                )}
                            />

                            <div
                                style={{
                                    width: "1px",
                                    height: "60%",
                                    backgroundColor: "#D0D5DD",
                                }}
                            />

                            <input
                                type="text"
                                name='phone'
                                placeholder="Mobile Number"
                                value={userInfo?.phone}
                                onChange={onChangeUserInfo}
                                style={{
                                    flex: 1,
                                    border: "none",
                                    outline: "none",
                                    padding: "0 12px",
                                    height: "100%",
                                    fontSize: "14px",
                                }}
                            />
                        </div>

                        {error.phone && <div className="error-text">{error.phone}</div>}
                    </div>

                </form>
            </div>

            {selectedCountryOption.code === "91" ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row-reverse",
                        padding: "28px 138px 20px 122px",
                    }}
                >
                    <div>

                        <OTPVerification
                            userId={userInfo.id}
                            sendOtpTo={userInfo.phone}
                            type={"mobile"}
                            btnText={
                                <Button
                                    text={"Continue"}
                                    onClick={() => { }}
                                    style={{ width: "141px", height: "47px", fontSize: '16px' }}
                                    isDisabled={error.phone || oldPhone === userInfo.phone}
                                />
                            }
                            callback={(verified) => {
                                if (verified) updateProfileInfo();
                            }}
                        />
                    </div>
                </div>
            ) : (
                <div className='flex w-full justify-end pr-[45px]  py-[22px]'>
                    <Button
                        text={"Continue"}
                        style={{ width: "141px", height: "47px", fontSize: '16px' }}
                        isDisabled={error.phone || oldPhone === userInfo.phone}
                        onClick={updateProfileInfo}
                    />

                </div>
            )
            }

        </Modal >
    )
}

export default EditPhone